export const blockIconsHardwareBalanceNew = (
	<span className='material-symbols-outlined'>balance</span>
);
